import { forkJoin, Observable } from 'rxjs';
import {
  Component,
  Input,
  HostBinding,
  SimpleChanges,
} from '@angular/core'
import { DatasetStatusModalComponent } from './dataset-status-modal.component'

import { ModalService } from '../../services/modal/modal.service'
import { ApiService } from '../../services/api/api.service'

@Component({
  selector: 'dataset-status',
  templateUrl: 'dataset-status.component.html',
  styleUrls: ['dataset-status.component.less'],
})
export class DatasetStatusComponent {
  @HostBinding('style.visibility') visibility: string
  @Input() datasets = []
  jobs = []
  iconColor: string

  constructor(
    private modalService: ModalService,
    private apiService: ApiService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['datasets']) {
      this.jobs = []
      let requests = []
      if(!this.datasets){
        return;
      }
      for (let dataset of this.datasets) {
        requests.push(this.apiService.load(`/analytics/${dataset}/status`, { skipLoader: true }))
      }

      forkJoin(requests)
        .subscribe(result => {
          for (let res of result) {
            if (res['jobs']) {
              this.jobs.push(res)
            }
          }
          this.checkIfVisible(this.jobs)
        })
    }
  }

  checkIfVisible(datasets) {
    this.iconColor = this.setIconColor()
    for (let dataset of datasets) {
      for (let job of dataset.jobs) {
        if (job.status != 'success') {
          this.visibility = 'inherit'
          return
        }
      }
    }
    this.visibility = 'hidden'
  }

  setIconColor() {
    for (let d of this.jobs) {
      for (let job of d.jobs) {
        if (job.status != 'success') {
          return 'yellow'
        }
      }
    }
    return 'green'
  }

  openStatusModal() {
    this.modalService.open(DatasetStatusModalComponent, {
      closable: false,
      inputs: {
        datasets: this.jobs
      },
      outputs: [],
      autofocus: false,
    })
  }
}
